import { getPrevQueryID, getPrevQuery } from "../QueryGetters";
export function getQueryIDs(store, r) {
    const qID = r.query && store.getQueryID(r.query);
    const qPrevID = getPrevQueryID(store, r);
    const qPrev = getPrevQuery(store, qPrevID);
    return {
        qID,
        qPrevID,
        qPrev
    };
}
//# sourceMappingURL=GetQueryIDs.js.map